// MohanDoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import mohandoc from '../../../../assets/images/Doctorsimages/drmohan .png' 
import favicon from "../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const MohanDoc = () => {
  const navigate = useNavigate(); 

  useEffect(() => {
    // SEO Content Implementation
    document.title = "Dr. Mohansundar | Best Homeopathy Consultant & Holistic Wellness Expert";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Mohansundar (BHMS, PGDMC), a highly skilled homeopathy consultant specializing in holistic healing and whole-person care. Expert in treating chronic ailments and lifestyle disorders with a gentle, root-cause approach. Book your appointment today for personalized homeopathic care."
      );
    }

    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best homeopathy doctor, homeopathy consultant near me, holistic healing practitioner, BHMS doctor for chronic diseases, homeopathy for lifestyle disorders, gentle healing approach, top homeopathy consultant, homeopathic treatment for whole-person care, Dr. Mohansundar homeopathy, homeopathy specialist in Chennai, medical cosmetology and homeopathy."
      );
    }

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalUrl = "https://www.h-cura.com/doctors/dr-mohansundar-consultant";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalUrl);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalUrl);
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    
    // Fix for image visibility in PDF: Ensure images are forced to be visible and CORS is handled
    container.classList.add('veenadoc-pdf-mode');
    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter,
        opacity: el.style.opacity
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
      el.style.opacity = '1'; // Force visibility
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    // Small delay to ensure styles apply before capture
    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true, // Crucial for image visibility
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        
        // Restore original styles
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          if (original) {
            el.style.transition = original.transition;
            el.style.animation = original.animation;
            el.style.transform = original.transform;
            el.style.filter = original.filter;
            el.style.opacity = original.opacity;
          }
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvas.width;
        const imgWidth = canvas.width * scaleFactor;
        const imgHeight = canvas.height * scaleFactor;
        
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr_Mohansundar_Profile.pdf');
      });
    }, 200);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Mohansundar</span>
                  <span className="veenadoc-title-credentials">(BHMS, PGDMC)</span>
                  <span className="veenadoc-title-location">Leading Homeopathy Consultant</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A dedicated and compassionate Homeopathy Consultant known for his commitment to natural healing and 
                    patient-centric care. With a solid academic foundation and diverse clinical experience, 
                    he provides long-term relief from chronic health issues through a holistic lens.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img 
                        src={mohandoc} 
                        alt="Dr. Mohansundar (BHMS, PGDMC) - Consultant Homeopathy Doctor" 
                        className="veenadoc-doctor-image" 
                        title='Dr. Mohansundar – Consultant in Homeopathy and Holistic Medicine' 
                      />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Mohansundar</h2>
                  <p>
                    Dr. Mohansundar (BHMS, PGDMC) is recognized as a leading Homeopathy Consultant & Holistic Health Practitioner. 
                    He earned his medical degree from the prestigious <strong>Venkateswara Homoeopathic Medical College and Hospital</strong>, 
                    where he mastered the intricate principles of classical homeopathy. 
                  </p>
                  <p>
                    To further enhance his clinical skills and offer a broader range of wellness solutions, he completed a 
                    Post Graduate Diploma in Medical Cosmetology (PGDMC) and received specialized training from 
                    <strong>Krystal Academy and Kats Academy</strong>.
                  </p>
                </div>

                {/* Clinical Journey */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Journey & Professional Contributions</h2>
                  <p>
                    Throughout his professional journey, Dr. Mohansundar has gained invaluable experience by working with esteemed institutions. 
                    His tenure at <strong>NIEPMD (National Institute for Empowerment of Persons with Multiple Disabilities)</strong> 
                    provided him with deep insights into managing complex health conditions with empathy and precision. 
                  </p>
                  <p>
                    Furthermore, his time at <strong>Dr. Parthasarathy Memorial Eye Care Hospital</strong> allowed him to understand 
                    the integration of specialized care with general wellness. These diverse roles have shaped him into a versatile 
                    consultant capable of addressing a wide array of physical and constitutional health concerns.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS, PGDMC</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">2+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathy & Medical Cosmetology</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Approach:</span>
                      <span className="veenadoc-info-value">Holistic & Gentle Healing</span>
                    </div>
                  </div>
                </div>

                {/* Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Expertise in Chronic and Lifestyle Disorders</h2>
                  <p>
                    Patients searching for the best homeopathy doctor for chronic diseases often consult Dr. Mohansundar for his 
                    analytical approach and personalized treatment plans. He specializes in managing lifestyle-induced ailments, 
                    respiratory issues, skin conditions, and stress-related disorders.
                  </p>
                  <p>
                    By combining his traditional homeopathic knowledge with modern clinical insights gained through his PGDMC, 
                    he offers a unique perspective on wellness that bridges the gap between internal health and external vitality. 
                    His expertise is particularly sought after by those who prefer a non-invasive, side-effect-free path to recovery.
                  </p>
                </div>

                {/* Why Choose */}
                <div className="veenadoc-article-block">
                  <h2>Why Choose Dr. Mohansundar?</h2>
                  <p>
                    In an era of quick-fix medical solutions, Dr. Mohansundar stands out as a practitioner who values time, 
                    listening, and detailed observation. Patients often describe him as an approachable and meticulous consultant 
                    who takes the time to explain the "why" behind every treatment. 
                  </p>
                  <p>
                    His goal is to empower his patients with the knowledge and tools they need to maintain their health long 
                    after the treatment is over. His practice is built on the pillars of trust, medical excellence, and a 
                    deep-rooted passion for helping individuals achieve their highest state of health.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Experience Transformative Holistic Care</h2>
                  <p>
                    If you are looking for a consultant homeopathy doctor near me who prioritizes your overall well-being and 
                    believes in the power of gentle, natural restoration, Dr. Mohansundar is the ideal choice. 
                    Experience a healthcare journey where you are seen as a person, not just a diagnosis.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>His mission:</strong> To empower patients with healthier lives, glowing skin, stronger hair, and renewed confidence through the transformative power of holistic homeopathy.
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                
                {/* Philosophy */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote style={{fontSize:'16px'}}>
                      "I believe in treating patients with a gentle approach to healing and treat the person as a whole, not just the disease."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Mohansundar's Philosophy of Care</p>
                  </div>
                  <p>
                    He believes that true healing goes beyond temporary relief of symptoms and requires addressing the 
                    root cause of illness through a person-centered approach.
                  </p>
                </div>

                {/* Practice Focus */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Focus</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">🌿</div>
                    <div className="veenadoc-location-details">
                      <h4>Homeopathic Treatment</h4>
                      <p>For chronic & lifestyle diseases</p>
                    </div>
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">✨</div>
                    <div className="veenadoc-location-details">
                      <h4>Whole-Person Care</h4>
                      <p>Root-cause focused healing</p>
                    </div>
                  </div>
                </div>

                {/* CTA Card */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Start your journey to holistic wellness with Dr. Mohansundar today.</p>
                  <button 
                    className="veenadoc-sidebar-btn-primary" 
                    onClick={() => window.location.href = 'tel:+919964688333'}
                  >
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download Dr. Mohansundar's Profile as PDF
        </button>
      </div>
    </>
  )
}

export default MohanDoc;
